class window.SitesList
  constructor: ->
    @parentItem = $('.side-menu .parent')

    @parentItemInit()


  parentItemInit: ->
    self = this

    $(self.parentItem).click ->
      $(this).toggleClass('open')



// WEBPACK FOOTER //
// ./assets/javascripts/app/side_menu.coffee